module.exports = __webpack_public_path__ + "static/media/Ryan-Curphey-Simulation.ecf54c36.pdf";